import { Mutation, Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { ISelectBranch, IBranch } from '../dto/PartialInfo';


@Module({ dynamic: true, store, name: 'partialInfo', namespaced: true })
class PartialInfo extends VuexModule {
  /**
   * @state
   * 委託営業所リスト
   */
  branchList: ISelectBranch[] = [];

  /**
   * @state
   * 資格コード
   */
  credentials: string = '';

  /**
   * @state
   * 大分類コード
   */
  majorCategory: string = '';

  /**
   * @state
   * 自治体名
   */
  municipalName: string = '';

  /**
   * @state
   * 資格名
   */
  credentialsName: string = '';

  /**
   * @state
   * 大分類名
   */
  majorCategoryName: string = '';

  /**
   * @Getter
   * 委託営業所リスト
   */
  get GET_BRANCH_LIST() {
    return this.branchList;
  }

  /**
   * @Getter
   * 資格コード
   */
  get GET_CREDENT() {
    return this.credentials;
  }

  /**
   * @Getter
   * 大分類コード
   */
  get GET_MAJOR() {
    return this.majorCategory;
  }

  /**
   * @Getter
   * 自治体名
   */
  get GET_MUNICIPAL() {
    return this.municipalName;
  }

  /**
   * @Getter
   * 資格名
   */
  get GET_CREDENT_NAME() {
    return this.credentialsName;
  }

  /**
   * @Getter
   * 大分類名
   */
  get GET_MAJOR_NAME() {
    return this.majorCategoryName;
  }

  /**
   * APIからの返却値を
   * v-selectに適用する型に変更し格納する
   * @param IBranch[]
   */
  @Action({})
  public setBranchList(param: IBranch[]) {
    const branchList: ISelectBranch[] = [];
    for (const p of param) {
      const branch: ISelectBranch = {
        text: p.branchName,
        value: p.branchId,
      };
      branchList.push(branch);
    }
    if (branchList.length > 0) {
      this.SET_BRANCH_LIST(branchList);
    }
  }

  @Action({})
  public moduleReset() {
    this.MODULE_RESET();
  }

  @Action({})
  public setCredentials(param: string) {
    this.SET_CREDENT(param);
  }

  @Action({})
  public setMajorCategory(param: string) {
    this.SET_MAJOR(param);
  }

  @Action({})
  public setMunicipalName(param: string) {
    this.SET_MUNICIPAL(param);
  }

  @Action({})
  public setCredentialsName(param: string) {
    this.SET_CREDENT_NAME(param);
  }

  @Action({})
  public setMajorCategoryName(param: string) {
    this.SET_MAJOR_NAME(param);
  }

  @Mutation
  private SET_BRANCH_LIST(param: ISelectBranch[]) {
    this.branchList = param;
  }

  @Mutation
  private MODULE_RESET() {
    this.branchList = [];
    this.credentials = '';
    this.majorCategory = '';
    this.municipalName = '';
    this.majorCategoryName = '';
    this.credentialsName = '';
  }

  @Mutation
  private SET_CREDENT(param: string) {
    this.credentials = param;
  }

  @Mutation
  private SET_MAJOR(param: string) {
    this.majorCategory = param;
  }

  @Mutation
  private SET_MUNICIPAL(param: string) {
    this.municipalName = param;
  }

  @Mutation
  private SET_CREDENT_NAME(param: string) {
    this.credentialsName = param;
  }

  @Mutation
  private SET_MAJOR_NAME(param: string) {
    this.majorCategoryName = param;
  }

}

export const partialInfoModule = getModule(PartialInfo);
